import * as React from "react";

import { IText } from "../../classes/text";

export interface IRecurrencePatternRepeatFrequencyDropdown {
	isTwoWayCalendar: boolean;
	repeatFreqency: string;
	text: IText;
	onChangeSelectedRepeatFrequency: (repeatFrequency: string) => void;
}

export const RecurrencePatternRepeatFrequencyDropdown: React.SFC<IRecurrencePatternRepeatFrequencyDropdown> = (props) => {

	const onChangeRepeatFrequency = (event: any) => {
		props.onChangeSelectedRepeatFrequency(event.target.value);
	};

	const txtRepeats = props.text.eventViews.repeats;
	const repeatFrequencyOptions = getRepeatFrequencyOptions(props.text, props.isTwoWayCalendar);

	return (
		<>
			<div className="CMS_title CMS_T6">{txtRepeats}</div>
			<select className="CMS_input" value={props.repeatFreqency} onChange={onChangeRepeatFrequency}>
				{repeatFrequencyOptions}
			</select>
		</>
	);

};

const getRepeatFrequencyOptions = (text: IText, isTwoWayCalendar: boolean) => {

	const txt = text.eventViews;

	const options = [
		<option value="Weekly" key="1">{txt.weekly}</option>,
		<option value="Monthly" key="2">{txt.monthly}</option>,
		<option value="Yearly" key="3">{txt.yearly}</option>,
	];

	if (isTwoWayCalendar) {
		options.splice(0, 0, <option value="Daily" key="4">{txt.daily}</option>);
	}

	return options;
};
